import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataTable, DataTableResource } from 'angular-4-data-table-bootstrap-4';

import { ModelService } from '../../../services';

@Component({
  selector: 'sn-attachment-list',
  templateUrl: './attachment-list.component.html',
  styleUrls: ['./attachment-list.component.css']
})
export class AttachmentListComponent implements OnInit {
  public mode_viewer:string = "viewer";
  public mode_picker:string = "picker";

  @Input() public columns:any;
  @Input() public related_type:any;
  @Input() public related_ID:any;
  @Input() public mode:string = this.mode_viewer;
  @Output() selectEvent = new EventEmitter();

  public attachments:Array<any> = [];
  public allAttachments:Array<any>;

  searchText = "";
  items = [];
  itemCount = 0;
  itemResource = new DataTableResource(this.attachments);
  lastParams;

  filterParams = [ "filename", "type", "sub_type", "filesize" ];

  isPicker() { return this.mode == this.mode_picker; }
  isViewer() { return this.mode == this.mode_viewer; }

  isVisible(col) {
    let tokens:Array<any> = this.columns.split(' ');
    return tokens.indexOf(col) >= 0;
  }

  reloadItems(params) {
    //console.log(params);
    this.lastParams = params;
    this.itemResource.query(params).then(
      items => {
        this.items = items;
        // console.log(items);
      }
    );
    this.itemResource.count().then(count => this.itemCount = count);
  }

  constructor(
    private modelService: ModelService
  ) { }

  ngOnInit() {
    this.modelService.loadRelatedFiles(this.related_type, this.related_ID).subscribe( 
      result => {
        this.allAttachments = result;
        this.attachments = this.allAttachments;
        this.itemResource = new DataTableResource(this.attachments);
        this.itemResource.count().then(count => this.itemCount = count);
      }
    )
    console.log("AttachmentListComponent", this.mode);
  }

  onChange($event) {
    var filteredItems = [];
    this.allAttachments.forEach( 
      u => {
        for (var i = 0; i < this.filterParams.length; i++) {
          var p = this.filterParams[i];
          if (this.isVisible(p) && u[p].toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0) {
            filteredItems.push(u);
            break;
          }
        }
      }
    ); 
    this.attachments = filteredItems;
    this.itemResource = new DataTableResource(this.attachments);
    this.lastParams.offset = 0; // reset the index/paging info
    this.reloadItems(this.lastParams);
  }

  // (rowClick)="rowClick($event)"
  // rowClick(rowEvent) {
  //   if (this.selectEvent) {
  //     this.selectEvent.emit({ selectedItem: rowEvent.row.item });
  //   }
  // }

  getDate(item) {
    return "na";
  }

  onSelect(item) {
    if (this.selectEvent) {
      this.selectEvent.emit({ selectedItem: item });
    }
  }

  getFilesize(filesize) {
    filesize = parseInt(filesize);
    var kb = filesize / 1024;
    var mb = kb / 1024;
    if (mb > 1) return `${mb.toFixed(2)} MB`;
    else if (kb > 1) return `${kb.toFixed(2)} KB`;
    return `${filesize} Bytes`;
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/list/attachment-list/attachment-list.component.ts